import { render, staticRenderFns } from "./CoachDetail.vue?vue&type=template&id=2213aad7&scoped=true&lang=pug"
import script from "./CoachDetail.vue?vue&type=script&lang=js"
export * from "./CoachDetail.vue?vue&type=script&lang=js"
import style0 from "./CoachDetail.vue?vue&type=style&index=0&id=2213aad7&prod&lang=scss"
import style1 from "./CoachDetail.vue?vue&type=style&index=1&id=2213aad7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2213aad7",
  null
  
)

export default component.exports